import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);

  return (
    <nav className="bg-white shadow sticky top-0 z-50 w-full">
      <div className="flex items-center justify-between px-2 sm:px-4 lg:px-6 py-3">
        {/* Left: Logo + Title */}
        <Link to="/" className="flex items-center space-x-3">
          <img
            src={logo}
            alt="SETM Nepal Logo"
            className="h-16 w-auto object-contain"
          />
          <span className="text-lg md:text-xl font-bold text-green-600">
            Sustainable Energy & Technology Management (SETM) NEPAL
          </span>
        </Link>

        {/* Mobile menu button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="lg:hidden p-2 ml-4 rounded-md focus:outline-none"
        >
          <svg
            className="w-6 h-6 text-gray-800"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Nav Links */}
        <div
          className={`${
            isOpen ? "block" : "hidden"
          } w-full lg:w-auto lg:block mt-4 lg:mt-0`}
        >
          <ul className="flex flex-col lg:flex-row lg:space-x-6 text-gray-800 font-medium relative">
            <li>
              <Link
                to="/"
                onClick={() => setIsOpen(false)}
                className="block px-4 py-2 hover:text-indigo-600"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about-us"
                onClick={() => setIsOpen(false)}
                className="block px-4 py-2 hover:text-indigo-600"
              >
                About Us
              </Link>
            </li>

            {/* About Us Dropdown - Click Toggle */}
            <li className="relative">
              <button
                onClick={() => setAboutOpen(!aboutOpen)}
                className="flex items-center px-4 py-2 hover:text-indigo-600 focus:outline-none"
              >
                What We Do
                <svg
                  className="w-4 h-4 ml-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {aboutOpen && (
                <ul className="absolute left-0 mt-1 bg-white shadow-lg rounded-md w-48 z-50">
                  <li>
                    <Link
                      to="/our-services"
                      onClick={() => {
                        setIsOpen(false);
                        setAboutOpen(false);
                      }}
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      Our Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/our-projects"
                      onClick={() => {
                        setIsOpen(false);
                        setAboutOpen(false);
                      }}
                      className="block px-4 py-2 hover:bg-gray-100"
                    >
                      Our Projects
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <Link
                to="/contact"
                onClick={() => setIsOpen(false)}
                className="block px-4 py-2 hover:text-indigo-600"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
